import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {},
    body: {
      overflow: 'hidden',
      paddingLeft: 80,
      paddingTop: 40,
    },
    bodyInner: {
      display: 'flex',
      flexDirection: 'column',
      gap: 40,
      backgroundColor: '#EDF4FF',
      borderRadius: 24,
      padding: 24,
      position: 'relative',
      '&:before, &:after': {
        content: '""',
        position: 'absolute',
        left: 42,
        top: 40,
        bottom: 30,
        width: 4,
        backgroundColor: theme.colors.neutral[1],
        transition: 'height .3s ease',
      },
    },
    title: {
      textTransform: 'capitalize',
      paddingLeft: 64,
    },
    group: {
      display: 'flex',
      flexDirection: 'column',
      gap: 40,
      position: 'relative',
      zIndex: 1,
    },
    header: {
      display: 'flex',
      gap: 24,
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    headerLeft: { display: 'flex', gap: 24, alignItems: 'center' },
    heading: {
      textTransform: 'capitalize',
    },
    icon: {
      position: 'relative',
      width: 40,
      height: 40,
      borderRadius: '100%',
      // backgroundImage:
      //   'linear-gradient(139.59deg, #BFC5CC 2.87%, #87909C 89.05%)',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // '&.active': {
      backgroundImage:
        'linear-gradient(139.59deg, #FFE16B 2.87%, #FFBA0F 58.46%, #FB8908 89.05%)',
      // },
    },
    cardWrapper: {
      position: 'relative',
      paddingLeft: 64,
    },
    card: {
      position: 'relative',
      '&:before, &:after': {
        content: '""',
        position: 'absolute',
        top: 24,
        left: -51,
        width: 12,
        height: 12,
        borderRadius: '100%',
        backgroundImage:
          'linear-gradient(139.59deg, #FFE16B 2.87%, #FFBA0F 33.47%, #FB8908 89.05%)',
      },
    },
    desc: {
      position: 'sticky',
      paddingTop: 40,
      paddingBottom: 40,
      top: 56,
      left: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
      width: 256,
      float: 'left',
    },

    listing: {
      display: 'flex',
      flexDirection: 'column',
      gap: 40,
    },
    info: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
    },
    maskcot: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      backgroundColor: '#EDF4FF',
      width: 120,
      height: 120,
      img: {
        maxWidth: 96,
        maxHeight: 96,
      },
    },
  }
})
